import React from "react";
import { Container, Header, SubHeader } from "./style";
import PropTypes from "prop-types";

const TextWithHeading = (props) => {
	const { heading, text, showInTabletAndMobile } = props;
	return (
		<Container showInTabletAndMobile={showInTabletAndMobile}>
			<Header>{heading}</Header>
			{text && (
				<SubHeader
					dangerouslySetInnerHTML={{
						__html: text,
					}}
				></SubHeader>
			)}
		</Container>
	);
};

TextWithHeading.propTypes = {
	heading: PropTypes.string.isRequired,
	text: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
};

TextWithHeading.defaultProps = {
	heading: "",
	text: "",
	showInTabletAndMobile: true,
};

export default TextWithHeading;
